<template>
  <div class="w1200 hspe">
    <div class="titlebox">
      <span class="titlename">您可能感兴趣的</span><span class="seeMore" />
    </div>
    <div class="column_li_box">
      <div v-for="item in list" :key="item.CONTENT_ID" class="column_li">
        <lisTemplate1 :list="item" />
      </div>
    </div>
  </div>
</template>
<script>
import lisTemplate1 from '@/components/centerlist_home/listTemplate1/index.vue'
export default {
  components: { lisTemplate1 },
  props: ['list']
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .titlebox{
    line-height: 40px;
    background-color: #fff;
    height: 40px;
  }
    .hspe{
        margin:20px 0;
      background-color: #FAFAFA;
    }
    .column_li{
        display: inline-block;
        margin-right: 33px;
        margin-top: 20px;
        width: 275px;
        height: 278px;
      transition: 0.3s;
      &:hover{
        transform: translate(0,-3px);
      }
    }
    .column_li:nth-child(4n){
      margin-right: 0;
    }
    .seeMore{
        margin-top: 20px;
        display: inline-block;
        height: 20px;
        font-size: 15px;
        float: right;
        margin-right:20px;
        color: #b2b2b2;
        cursor: pointer;
        &:hover{
            color: #ed4040;
        }
    }
    .titlename{
        display: inline-block;
        height: 20px;
        line-height: 20px;
        border-left: 2px solid #ed4040;
        padding-left: 10px;
        font-size: 16px;
        margin-left: 20px;
        font-weight: 600;
    }

</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .column_li{
      width: 100%;
      height: auto;
      border-bottom: 1px solid #eee;
    }
    .column_li_box{
      padding: 0 20px;
      background-color: #fff;
    }
  }
</style>

